<template>
  <v-container fluid class="role-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Role Information</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Routes</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create New Role</p>
                        <v-text-field
                          class="mb-4"
                          v-model="role.rolecode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Role Code"
                          persistent-hint
                          single-line hint="Enter the role Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="role.rolename"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Role Name"
                          persistent-hint
                          single-line hint="Enter the role name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=roletypes
                          v-model="role.roletype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the role type">
                        </v-select>
                          <v-switch
                            v-model="role.rolestatus"
                            color="primary"
                            v-bind:label="role.rolestatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/role/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="8">
                      <p class="text-h5">Role Details</p>
                      <v-form>
                        <v-row justify="center">
                        <v-col md="4">
                          <v-text-field
                            v-model="accessname"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Access Name"
                            persistent-hint
                            single-line hint="Role access name">
                          </v-text-field>
                        </v-col>
                        <v-col md="4">
                          <v-text-field
                            v-model="accesspath"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Access Path"
                            persistent-hint
                            single-line hint="Role access path">
                          </v-text-field>
                        </v-col>
                        <v-col md="2">
                          <v-switch
                            v-model="accessenabled"
                            :label="role.accessenabled"
                          ></v-switch>
                        </v-col>
                        <v-col md="2">
                          <v-btn
                            class="button-shadow"
                            color="success"
                            @click="addAccess()">
                            Add
                          </v-btn>
                        </v-col>
                        </v-row>
                          <v-data-table
                            :headers="headers"
                            :items="access"
                            :items-per-page="100"
                            class="elevation-0"
                          ></v-data-table>
                      </v-form>
                    </v-col>
                  </v-row>
                    <v-row justify="center">
                    <v-col cols="12" md="8">
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createRole()">
                            Save
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      headers: [
        { text: 'Name', value: 'accessname' },
        { text: 'Path', value: 'accesspath' },
        { text: 'Enabled', value: 'accessenabled' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      access: [],
      accessname: undefined,
      accesspath: undefined,
      accessenabled: undefined,
      step: 1,
      role: {
        rolestatus: 'Active'
      },
      roletypes: ['General', 'Managerial', 'Associate'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Role', ['insertRole','getRolesRequest']),
    checkError(){
      if(!this.role.rolecode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.role.rolename){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.role.roletype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    addAccess(){
      this.access.push({
        accessname: this.accessname,
        accesspath: this.accesspath,
        accessenabled: this.accessenabled,
      });
    },
    createRole() {
      this.role.access = this.access;
      console.log(this.role);
      this.insertRole(this.role);
      this.getRolesRequest();
      router.push('/role/list');
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.role.roleimage = file;
      this.role.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Role', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
